import { useTranslation } from 'react-i18next'
import { PortfolioIcon } from '@/components/ui/PortfolioIcon'

const projects = [
  { key: 'gateway', image: 'gateway' },
  { key: 'fireAlarm', image: 'fire' },
  { key: 'vending', image: 'vending' },
  { key: 'web', image: 'software' },
] as const

export const Projects = () => {
  const { t } = useTranslation()
  return (
    <section id="projects" className="projects-section section-pad">
      <div className="shell">
        <div className="section-heading">
          <div>
            <p className="eyebrow">{t('portfolio.projects.eyebrow')}</p>
            <h2>{t('portfolio.projects.title')}</h2>
          </div>
          <a className="text-link" href="#contact">
            {t('portfolio.consulting.cta')}
            <PortfolioIcon name="arrow" />
          </a>
        </div>
        <p className="section-intro">{t('portfolio.projects.description')}</p>
        <div className="project-grid">
          {projects.map(({ key, image }) => (
            <article className="project-card" key={key}>
              <img
                className={key === 'vending' ? 'project-vending-image' : key === 'fireAlarm' ? 'project-machine-image' : undefined}
                src={`/images/portfolio/${image}.webp`}
                alt={t(`portfolio.projects.items.${key}.alt`, { defaultValue: t(`portfolio.projects.items.${key}.title`) })}
                width="350"
                height="220"
                loading="lazy"
              />
              <div className="project-copy">
                <h3>{t(`portfolio.projects.items.${key}.title`)}</h3>
                <p className="project-tags">
                  {(
                    t(`portfolio.projects.items.${key}.tags`, {
                      returnObjects: true,
                    }) as string[]
                  ).join(' · ')}
                </p>
                <p className="project-description">
                  {t(`portfolio.projects.items.${key}.description`)}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
